import { FunctionComponent, useEffect, useState } from 'react';
import NavColumn from './NavColumn';
import { GridRow } from '@lmig/lmds-react-grid';
import RichText from 'Feature/PageContent/Shared/Tiles/RichText';

const MegaMenu: FunctionComponent<IReactMegaMenu> = (props: IReactMegaMenu) => {
  const [navColumns, setNavColumns] = useState<IReactNavColumn[]>([]);
  useEffect(() => {
    if (props && props.Columns) setNavColumns(props.Columns);
  }, [props]);
  const [richText, setRichText] = useState<IReactNavColumn[]>([]);

  const [navLinks, setNavLinks] = useState<IReactNavColumn[]>([]);
  useEffect(() => {
    setRichText(navColumns.filter((el) => el.RichTexts && el.RichTexts.length > 0));
    setNavLinks(navColumns.filter((el) => !(el.RichTexts && el.RichTexts.length > 0)));
  }, [navColumns]);

  if (props) {
    return richText && richText.length > 0 ? (
      <div className="mega-menu-drawer-container">
        <div className="nav-links-section">
          <GridRow vAlign="stretch" justify="around">
            {navLinks.map((column: IReactNavColumn) => {
              if (column?.Sections?.length && column?.Sections?.length > 0) return <NavColumn {...column} />;
              return null;
            })}
          </GridRow>
        </div>
        <div className="rich-text-container">
          <div className="rich-text-inner">
            <RichText
              content={
                (() => {
                  if (richText && richText[0] && richText[0].RichTexts && richText[0].RichTexts[0])
                    return richText[0].RichTexts[0]?.RichText;
                })() || ''
              }
            />
          </div>
        </div>
      </div>
    ) : (
      <div className="mega-menu-drawer-container">
        <div className="nav-links-section" id="nav-links-section-full-width">
          <GridRow vAlign="stretch" justify="around">
            {navLinks.map((column: IReactNavColumn) => {
              if (column?.Sections?.length && column?.Sections?.length > 0) return <NavColumn {...column} />;
              return null;
            })}
          </GridRow>
        </div>
      </div>
    );
  } else return <></>;
};
export default MegaMenu;
